
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n479Child = []
  var n480Child = []
  var n481Child = []
  n481Child = n481Child.concat(text(t('.state_name')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n481 = h('label', props, n481Child)
  n480Child.push(n481)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n480 = h('div', props, n480Child)
  n479Child.push(n480)
  var n482Child = []
  if(shadow.names.indexOf("") == -1) {
    shadow.names.push("")
  }
  var v483 = shadow.names
  Object.keys(v483).forEach(function (index) {
    var value = v483[index]
    var n484Child = []
    var n485Child = []
    var n486Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'type', val: "text"},{name:'name', val: `names[${index}]`},{name:'value', val: value}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n486 = h('input', props, n486Child)
    n485Child.push(n486)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n485 = h('div', props, n485Child)
    n484Child.push(n485)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'key', val: `names[${index}]`}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n484 = h('div', props, n484Child)
    n482Child.push(n484)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n482 = h('div', props, n482Child)
  n479Child.push(n482)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n479 = h('div', props, n479Child)
  n0Child.push(n479)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  